import React, {Component, createRef} from 'react';
import {Button, Card, CardBody, CardGroup, Col, Container, Row} from 'reactstrap';
import Login_ICON from '../../assets/img/login.png'
import {Input} from "semantic-ui-react";
import './Login.css'
import Cookies from 'js-cookie'
import * as common from '../../const/Common/CommonFunc';
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import axios from "../../axios/axios_authorization";
// import axios_ori from "axios";
import * as qs from "qs";
import * as config from '../../const/config/config'
import ForgotPassword from "./ForgotPassword/ForgotPassword";
import $ from "jquery";
import apiConfig from '../../axios/axios_api_services';
import * as keys from "../../const/key/Key";
import * as routeConstants from "../../const/route/Route";

class Login extends Component {
  state = {
    username: '',
    password: '',
    isForgotPassword: false
  };
  loginHandler = () => {
    let username = this.state.username;
    let password = this.state.password;

    if (username.trim() === '' || password.trim() === '') {
      common.notifyMessage("Please enter login credentials");
    } else {
      this.loginHandler_();
    }
  };

  loginHandler_ = () => {
    let username = this.state.username;
    let password = this.state.password;

    if (username.trim() === '' || password.trim() === '') {
      common.notifyMessage("Please enter login credentials")
    } else {

      this.props.spinnerHandler(true);

      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": "Basic " + config.CLIENT_SECRET
      };

      const data = {
        username: username.trim(),
        password: password.trim(),
        grant_type: 'password'
      };

      // Get OAuth2 Token
      axios.post(apiConfig.OAUTH, qs.stringify(data), {headers: headers})
        .then(response => {

          // axios_ori.create().defaults.headers.common['Authorization'] = "Bearer "+response.data.access_token

          Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token); //access-token (68a6102f6ed24899420170004a0273b8)
          Cookies.set('9b8558ba3f051677daf36ebfc67f29fa', response.data.refresh_token); // refresh-token (9b8558ba3f051677daf36ebfc67f29fa)

          this.checkUserRole(response.data.user);
          // this.checkUserRole_VisitorTags(response.data.user);
        })
        .catch(error => {
          this.props.spinnerHandler(false);
          common.notifyMessage("You've entered an incorrect username/password combination", 0, 3);
        });
    }
  };

  /*
  CORP_ADMIN,  SYS_ADMIN,  HELP_DESK,
  CORP_OPER,  PARK_ADMIN,  PARK_OPER,  SYS_OPER,  PARK_USER,
  RECEPTION, EXTERNAL_RECEPTION,
  CORP_HOST, CORP_EVENT_ADMIN, CORP_EVENT_ORGANIZER
  */

  checkUserRole_VisitorTags = (userObj) => {
    this.props.spinnerHandler(false);
    if (userObj !== undefined || userObj !== null) {
      this.props.userHandler(userObj);
      let userRoles = userObj.userRoles;

      if (userRoles === "RECEPTION") {
        this.props.history.push('/reception/dashboard')
      } else {
        common.notifyMessage("Can't find user role");
      }
    } else {
      common.notifyMessage("Can't find user role");
    }
  };

  checkUserRole = (userObj) => {
    this.props.spinnerHandler(false);

    if (userObj !== undefined || userObj !== null) {

      this.props.userHandler(userObj);
      let userRoles = userObj.userRoles;

      if (userRoles === "RECEPTION") {
        this.props.history.push('/reception/dashboard')

      } else if (userRoles === "SYS_ADMIN" || userRoles === "HELP_DESK") {
        this.props.history.push("/super/dashboard");

      } else if (userRoles === "CORP_ADMIN") {
        let obj = userObj;
        obj.corporateId = userObj.corporates.length !== 0 ? userObj.corporates[0].corporateId : 0;
        Cookies.set('3c8bed3b2d6ba6d3076ee8d2f588a4dd', obj);
        this.props.history.push("/corporate/dashboard");

      } else if (userRoles === "CORP_OPER" || userRoles === "PARK_ADMIN" || userRoles === "PARK_OPER" || userRoles === "SYS_OPER" || userRoles === "PARK_USER" || userRoles === "PARK_RECEPTION") {
        this.props.history.push("/parktags");

      } else if (userRoles === "CORP_EVENT_ADMIN") {
        this.props.history.push("/eventtags/dashboard");
        // this.props.history.push("/spacetags/workspace");

      } else if (userRoles === "CORP_HOST") {
        this.props.history.push('/host/dashboard')

      } else if (userRoles === "EXTERNAL_RECEPTION") {
        this.props.history.push('/external-reception/dashboard')

      } else if (userRoles === "CORP_EVENT_ORGANIZER") {
        this.props.history.push("/eventorganizer/dashboard")

      } else if (userRoles === keys.HR_USER_ROLE) {
        this.props.history.push(`${routeConstants.HR_ROUTE_PATH}/dashboard`)

      } else if (userRoles === keys.NOTIFICATION_OPERATOR_ROLE) {
        this.props.history.push(`${routeConstants.NOTIFICATION_ROUTE_PATH}/single/create`)

      } else {
        common.notifyMessage("Can't find user role");
      }
    } else {
      common.notifyMessage("Can't find user role");
    }
  };


  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };


  inputRef_username = createRef();
  inputRef_password = createRef();

  componentDidMount() {
    document.title = "Miracle Dome";
    this.inputRef_username.current.focus();

    $('.login-username').bind('keyup', (event) => {
      if (event.keyCode === 13) {
        this.inputRef_password.current.focus();
      }
    });
    $('.login-password').bind('keyup', (event) => {
      if (event.keyCode === 13) {
        this.loginHandler();
      }
    });
  }


  render() {
    return (
      <div className={"app flex-row align-items-center login-background animated bounceInLeft"}>
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup style={{boxShadow: '0 30px 60px 0 rgba(0,0,0,0.3)'}}>
                {/*<h1 className={"logo-name"}>Visitor <span style={{color: '#53bd52'}}>#</span>tags</h1>*/}
                {/*<h1 className={"logo-name"}>*/}
                {/*<img src="http://52.66.44.65:8080/visitorTagTemp.png" alt="." style={{height: '120px'}} />*/}
                {/*</h1>*/}

                <Card className="p-4" style={{border: 'none'}}>

                  {
                    !this.state.isForgotPassword ?
                      <CardBody>
                        <h1>Login</h1>
                        <p className="text-muted">Sign In to your account</p>
                        <Input
                          ref={this.inputRef_username}
                          focus={true}
                          style={txtStyle}
                          className={"login-username"}
                          icon='user'
                          iconPosition='left'
                          label={{tag: true, content: 'Username'}}
                          labelPosition='right'
                          placeholder='Enter Username'
                          onChange={this.handleChange("username")}
                        />

                        <Input
                          ref={this.inputRef_password

                          }
                          className={"login-password"}
                          style={txtStyle}
                          icon='lock'
                          iconPosition='left'
                          type={"password"}
                          label={{tag: true, content: 'Password'}}
                          labelPosition='right'
                          placeholder='Enter Password'
                          onChange={this.handleChange("password")}
                        />

                        <Row>
                          <Col xs="6">
                            <Button onClick={this.loginHandler} className="ui button px-5">Login</Button>
                          </Col>
                          <Col xs="6">
                            <p className={"login-right-side-forgot-password"}
                               onClick={() => this.setState({isForgotPassword: true})}>Forgot password?</p>
                          </Col>
                        </Row>
                        {/*<hr/>*/}
                        {/*<Row>*/}
                        {/*  <Col xs="12">*/}
                        {/*    <span>Don't have an account? </span>*/}
                        {/*    <span className={"login-right-side-forgot-password"}*/}
                        {/*       onClick={() => this.props.history.push(`${routeConstants.PUBLIC_CORPORATE_SIGNUP}`)}> Register company here</span>*/}
                        {/*  </Col>*/}
                        {/*</Row>*/}
                      </CardBody>
                      :
                      <ForgotPassword backToSigninFunc={() => this.setState({isForgotPassword: false})}/>
                  }

                </Card>
                <Card className="text-white  py-5 d-md-down-none login-right-side"
                      style={{border: 'none', width: '44%', height: '301px'}}>

                  <img src={Login_ICON} style={{width: '100%', height: '180%', objectFit: 'contain'}} alt={"."}/>

                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

let txtStyle = {
  marginBottom: '10px',
  height: '45px',
  width: '100%'
};

const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
});

const mapDispatchToProps = (dispatch) => {
  return {

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // userReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
